import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Container } from '@material-ui/core';
import { FONT_MAIN } from '../../../../constants/fonts';
import { ExpiredFooterBody } from './ExpiredFooterBody';
import { ValidFooterBody } from './ValidFooterBody';
import { useCellTimer } from '../../../../components/PriceTimer/hooks';

const FooterBackgroundStyle = styled.div`
  bottom: 0px;
  left: 0px;
  height: 72px;
  width: 100%;
  background-color: #FFFFFF;
  box-shadow: 0 3px 4px 0 rgba(0,0,0,0.14), 0 3px 3px -2px rgba(0,0,0,0.12), 0 1px 8px 0 rgba(0,0,0,0.2);
  position: fixed;
`;

const FooterContainerStyle = styled(Container)`
  display: flex;
  align-items: center;
  color: rgba(0,0,0,0.87);
  font-family: "Nimbus CEZ OT";
  font-size: 15.38px;
  letter-spacing: 0.25px;
  line-height: 20px;
  align-items: center;
  min-height: 100%;
  .priceAndTime {
    flex: 1;
    display: flex;
    .price {
      font-weight: bold;
      margin-left: 3px;
    }
    .priceTimer {
      margin-left: 15px;
      height: 100%;
      color: rgba(0,0,0,0.6);
      font-family: "${FONT_MAIN}";
      font-size: 13px;
      letter-spacing: 0.21px;
      line-height: 20px;
      .timeIcon {
        height: 14px;
        margin-right: 3px;
        > svg {
          width: 14px;
          height: 14px;
        }
      }
    }
  }
  .actionButton {
    margin-right: 15px;
  }

  @media all and (width <= 650px) {
    .actionButton {
      margin-right: 0px;
    }
  }
`;


export const FOOTER_LABEL_PREFIX = `app.contract.buy.footer`;

export const BuyFooter = ({ onBuy, buyInfo, product, releasing, manualPrice, manualRate, onRefresh, role, contract, remainingPurchaseCount }) => {
  const productPriceObj = releasing ? product?.salePrice : product?.price;
  const { timeLeft } = useCellTimer(productPriceObj?.validTo);

  const productExpired = productPriceObj && timeLeft <= 0;

  return (
    <FooterBackgroundStyle>
      <FooterContainerStyle maxWidth={'xl'}>
        {(productExpired && !manualPrice) ?
          <ExpiredFooterBody
            onRefresh={onRefresh}
          /> :
          <ValidFooterBody
            product={product}
            releasing={releasing}
            isFix={contract.isFix}
            manualPrice={manualPrice}
            manualRate={manualRate}
            onBuy={onBuy}
            buyInfo={buyInfo}
            role={role}
            timeLeft={timeLeft}
            remainingPurchaseCount={remainingPurchaseCount}
          />}
      </FooterContainerStyle>
    </FooterBackgroundStyle>
  );
};

BuyFooter.propTypes = {
  onBuy: PropTypes.func,
  onRefresh: PropTypes.func,
  buyInfo: PropTypes.object,
  product: PropTypes.object,
  contract: PropTypes.object,
  releasing: PropTypes.bool,
  manualPrice: PropTypes.number,
  manualRate: PropTypes.number,
  role: PropTypes.string,
  remainingPurchaseCount: PropTypes.number,
};
